import { render, staticRenderFns } from "./rm-query-parameters-modal.vue?vue&type=template&id=0a8c23ba"
import script from "./rm-query-parameters-modal.vue?vue&type=script&lang=js"
export * from "./rm-query-parameters-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports